import React, { useState, useEffect } from 'react';
import { reportError } from '../../utils/errorHandling.js';

function AdminCarbonTokens({ supabaseClient }) {
  const [tokens, setTokens] = useState([]);
  const [users, setUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState('');
  const [amount, setAmount] = useState('');
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    async function fetchData() {
      try {
        setIsLoading(true);
        const { data: userList } = await supabaseClient.from('users').select('id, name, email').order('name');
        setUsers(userList || []);
        const { data: tokenList } = await supabaseClient.from('carbon_tokens').select('*').order('issued_at', { ascending: false });
        setTokens(tokenList || []);
      } catch (err) {
        console.error('Error loading tokens:', err);
        reportError(err);
      } finally {
        setIsLoading(false);
      }
    }
    fetchData();
  }, [supabaseClient]);

  const handleIssue = async (e) => {
    e.preventDefault();
    try {
      if (!selectedUser || !amount) return;
      const { error } = await supabaseClient.from('carbon_tokens').insert({
        user_id: selectedUser,
        amount: parseInt(amount, 10)
      });
      if (error) throw error;
      // Refresh list
      const { data: updated } = await supabaseClient.from('carbon_tokens').select('*').order('issued_at', { ascending: false });
      setTokens(updated || []);
      setAmount('');
      setSelectedUser('');
    } catch (err) {
      console.error('Issue tokens error:', err);
      reportError(err);
    }
  };

  if (isLoading) return <p className="text-center p-4">Loading...</p>;

  return (
    <div>
      <h2 className="text-2xl font-bold mb-4">Carbon Tokens Management</h2>
      <form onSubmit={handleIssue} className="mb-6 flex space-x-4">
        <select value={selectedUser} onChange={(e) => setSelectedUser(e.target.value)} className="border p-2 rounded">
          <option value="">Select User</option>
          {users.map(u => (
            <option key={u.id} value={u.id}>{u.name} ({u.email})</option>
          ))}
        </select>
        <input type="number" placeholder="Amount" value={amount} onChange={(e) => setAmount(e.target.value)} className="border p-2 rounded w-24" />
        <button type="submit" className="px-4 py-2 bg-green-600 text-white rounded">Issue</button>
      </form>
      <table className="min-w-full divide-y divide-gray-200">
        <thead>
          <tr>
            <th className="px-4 py-2 text-left">User</th>
            <th className="px-4 py-2 text-left">Amount</th>
            <th className="px-4 py-2 text-left">Issued At</th>
          </tr>
        </thead>
        <tbody>
          {tokens.map(token => (
            <tr key={token.id} className="border-t">
              <td className="px-4 py-2">{users.find(u => u.id === token.user_id)?.name || token.user_id}</td>
              <td className="px-4 py-2">{token.amount}</td>
              <td className="px-4 py-2">{new Date(token.issued_at).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default AdminCarbonTokens;
window.AdminCarbonTokens = AdminCarbonTokens;
